import axios from "axios";
import config from "../../appConfig";
import { getURLParameterVal } from './../store/helpers';
import axiosRetry from 'axios-retry';

class HttpService {
    constructor() {
        const headers = this.getAuthHeaders();
        const service = axios.create({
            baseURL: config.API_URL,
            headers: headers,
            timeout: 0,
        });

        axiosRetry(service, {
            retries: 2,
            retryDelay: (retryCount) => {
                return retryCount * 200;
            }
        });

        service.interceptors.response.use(this.handleSuccess, this.handleError);

        this.service = service;
    }

    getAuthHeaders() {
        const isOrigin = getURLParameterVal('type')?.toLowerCase() == 'origin';

        if (isOrigin) return {};

        const token = getURLParameterVal('token') ?? window.localStorage.getItem("token");

        if (!token) return {};
        
        return {
            "Authorization": `Bearer ${token}`,
        };
    }

    handleSuccess = (response) => {
        return response;
    }

    handleError = (error) => {
        switch (error.response?.status) {
            case 401:
                // Token expired
                delete this.service.defaults.headers["Authorization"];
                window.localStorage.removeItem("token");
                console.log("Token expired, please regenerate token and try again.");
                break;
            case 404:
                // Not found
                //this.redirectTo("/404");
                break;
            default:
                // Internal server error
                //this.redirectTo("/500");
                break;
        }

        return Promise.reject({...error});
    }

    redirectTo(url) {
        window.location.href = url;
    }

    get(config) {
        if (config instanceof String || typeof config === 'string') {
            return this.service.get(config);
        }

        return this.service.request({ method: 'GET', ...config });
        // return this.service.get(...args);
    }

    post(config) {
        return this.service.request({ method: 'POST', ...config });
        // return this.service.post(...args);
    }

    put(config) {
        return this.service.request({ method: 'PUT', ...config });
        // return this.service.put(...args);
    }

    patch(config) {
        return this.service.request({ method: 'PATCH', ...config });
        // return this.service.patch(...args);
    }

    delete(config) {
        return this.service.request({ method: 'DELETE', ...config });
        // return this.service.delete(...args);
    }

    request(...args) {
        return this.service.request(...args);
    }
}

export default new HttpService();